import { useState, useEffect } from "react";
import { II } from "../../components/common/Icons";
import PMModal from "./PMModal";
import { usePMData } from "../../context/PMContext";import "../../assets/styles/PM/PMLeavePg.css";

function PMLeavePg() {
  const {
    pmLeaveReqs,
    pmProjects,
    handleLeaveAction,
    resendLeave,
    refreshPMData,
    loading
  } = usePMData();

  const [requests, setRequests] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");
  const [showResend, setShowResend] = useState(null);
  const [resendDays, setResendDays] = useState("");
  const [resendComment, setResendComment] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    setRequests(Array.isArray(pmLeaveReqs) ? [...pmLeaveReqs] : []);
  }, [pmLeaveReqs]);

  // Filter requests
  const filteredRequests = filter === "all" ?
  requests :
  filter === "pending" ?
  requests.filter((r) => r.pm_status === "pending" || r.status === "pending" || r.status === "resubmitted") :
  filter === "approved" ?
  requests.filter((r) => r.status === "approved" || r.status === "manager_approved") :
  requests.filter((r) => r.status === filter);

  // Handle Approve/Reject
  const handleAction = async (id, action) => {
    try {
      let actionComment = action === "approved" ? "Approved by PM" : "Rejected by PM";
      if (action === "rejected") {
        const reason = window.prompt("Enter reject reason for employee:");
        if (reason === null) return;
        if (!String(reason).trim()) {
          alert("Reject reason is required.");
          return;
        }
        actionComment = String(reason).trim();
      }
      await handleLeaveAction(
        id,
        action,
        actionComment
      );
      setSuccessMsg(`Request ${action} successfully!`);
      setTimeout(() => setSuccessMsg(""), 4000);
    } catch (e) {
      alert("Error: " + e.message);
    }
  };

  // Handle Resend with modified duration
  const handleResend = async () => {
    if (!showResend || !resendDays || !resendComment.trim()) return;

    const days = parseInt(resendDays);
    if (isNaN(days) || days < 1) return;

    try {
      await resendLeave(showResend.id, days, resendComment.trim());
      setSuccessMsg(`Request resent with modified duration (${days} day${days !== 1 ? "s" : ""})`);
      setShowResend(null);
      setResendDays("");
      setResendComment("");
      setTimeout(() => setSuccessMsg(""), 5000);
    } catch (e) {
      alert("Error: " + e.message);
    }
  };

  const getStatusChip = (status) => {
    const map = {
      pending: "chip-wn",
      approved: "chip-ok",
      manager_approved: "chip-ok",
      rejected: "chip-dn",
      resent: "chip-ip",
      resubmitted: "chip-p"
    };
    return "chip " + (map[status] || "chip-wn");
  };

  if (loading) {
    return (
      <div className="pmleavepg-inline-1">
        <div className="ob-pending-dot pmleavepg-inline-2"></div>
        <div className="pmleavepg-inline-3">Loading leave requests...</div>
      </div>);

  }

  return (
    <div>
      <div className="sec">Leave / WFH Approvals</div>
      
      {successMsg &&
      <div className="toast">
          {II("chk", 16, { c: "#2563eb" })} {successMsg}
        </div>
      }

      {/* Filter Tabs */}
      <div className="pmleavepg-inline-4">
        {[
        { k: "all", l: "All Requests", count: requests.length },
        { k: "pending", l: "Pending", count: requests.filter((r) => r.pm_status === "pending" || r.status === "pending" || r.status === "resubmitted").length },
        { k: "approved", l: "Approved", count: requests.filter((r) => r.status === "approved" || r.status === "manager_approved").length },
        { k: "rejected", l: "Rejected", count: requests.filter((r) => r.status === "rejected").length },
        { k: "resent", l: "Resent", count: requests.filter((r) => r.status === "resent").length }].
        map((f) =>
        <div
          key={f.k}
          className={`${"chip " + (filter === f.k ? "chip-p" : "chip-wn")} pmleavepg-dyn-3`}

          onClick={() => setFilter(f.k)}>
          
            {f.l} ({f.count})
          </div>
        )}
      </div>

      {/* Leave Requests Table */}
      <div className="cd">
        <div className="cd-h">
          <div className="cd-t">Leave & WFH Requests</div>
          <div className="cd-s">
            {filteredRequests.length} requests · {requests.filter((r) => r.pm_status === "pending" || r.status === "pending" || r.status === "resubmitted").length} actionable
          </div>
        </div>
        
        <div className="cd-b pmleavepg-inline-6">
          <table className="tbl">
            <thead>
              <tr>
                <th>ID</th>
                <th>Employee</th>
                <th>Project</th>
                <th>Type</th>
                <th>From → To</th>
                <th>Days</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Manager Comment</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRequests.length === 0 ?
              <tr>
                  <td colSpan="10" className="pmleavepg-inline-7">
                    No leave requests found
                  </td>
                </tr> :

              filteredRequests.map((r) => {
                const projectName = pmProjects.find((p) => p.pid === r.project)?.name || r.project;
                return (
                  <tr key={r.id}>
                      <td className="pmleavepg-inline-8">{r.id}</td>
                      <td className="pmleavepg-inline-9">
                        {r.empName}
                        <div className="pmleavepg-inline-10">{r.empId}</div>
                      </td>
                      <td className="pmleavepg-inline-11">{projectName}</td>
                      <td>
                        <span className="chip chip-p pmleavepg-inline-12">{r.type}</span>
                      </td>
                      <td className="pmleavepg-inline-13">
                        {r.from}<br />→ {r.to}
                      </td>
                      <td className="pmleavepg-inline-14">
                        {r.days}
                        {r.resendDays !== null && r.resendDays !== r.days &&
                      <div className="pmleavepg-inline-15">
                            Suggested: {r.resendDays}d
                          </div>
                      }
                      </td>
                      <td className="pmleavepg-inline-16">
                        <div className="pmleavepg-inline-17">
                          {r.reason}
                        </div>
                      </td>
                      <td>
                        <span className={getStatusChip(r.status)}>{r.status === 'manager_approved' ? 'approved' : r.status}</span>
                      </td>
                      <td className="pmleavepg-inline-18">
                        {r.mgrComment ?
                      <div style={{ "--pmleavepg-2-color":



                        r.status === "rejected" ? "#ef4444" : r.status === "resent" ? "#3b82f6" : "#475569" }} className="pmleavepg-dyn-2">
                        
                            {r.mgrComment}
                          </div> :

                      <span className="pmleavepg-inline-19">—</span>
                      }
                      </td>
                      <td>
                        <div className="pmleavepg-inline-20">
                          {(r.pm_status === "pending" || r.status === "pending" || r.status === "resubmitted") &&
                        <>
                              <button
                            className="btn btn-s btn-ok pmleavepg-inline-21"

                            onClick={() => handleAction(r.id, "approved")}
                            title="Approve">
                            
                                {II("chk", 11)} Approve
                              </button>
                              <button
                            className="btn btn-s btn-dn pmleavepg-inline-22"

                            onClick={() => handleAction(r.id, "rejected")}
                            title="Reject">
                            
                                {II("x", 11)} Reject
                              </button>
                              <button
                            className="btn-o btn-s pmleavepg-inline-23"

                            onClick={() => {
                              setShowResend(r);
                              setResendDays(String(r.days));
                              setResendComment("");
                            }}
                            title="Resend with changes">
                            
                                {II("send", 11)} Resend
                              </button>
                            </>
                        }
                          {(r.status === "approved" || r.status === "rejected" || r.status === "manager_approved") &&
                        <span className="pmleavepg-inline-25">
                              Completed
                            </span>
                        }
                        </div>
                      </td>
                    </tr>);

              })
              }
            </tbody>
          </table>
        </div>
      </div>

      {/* ========== RESEND MODAL ========== */}
      <PMModal
        open={!!showResend}
        onClose={() => {
          setShowResend(null);
          setResendDays("");
          setResendComment("");
        }}
        title={`Resend with Modification — ${showResend?.id || ""}`}>
        
        {showResend &&
        <div>
            <div className="pmleavepg-inline-26">





            
              <div className="pmleavepg-inline-27">
                {showResend.empName} — {showResend.type}
              </div>
              <div className="pmleavepg-inline-28">
                Original request: <strong>{showResend.days} day(s)</strong> · {showResend.from} to {showResend.to}
              </div>
              <div className="pmleavepg-inline-29">
                Reason: {showResend.reason}
              </div>
            </div>

            <div className="pmleavepg-inline-30">







            
              <strong>Resend Flow:</strong> You modify the duration and add a comment → 
              Status becomes "Resent" → Employee sees your suggestion → 
              Employee can edit and resubmit for your final approval.
            </div>

            <div className="fg">
              <label className="fl">Suggested Duration (days) *</label>
              <input
              className="fi"
              type="number"
              min="1"
              max={showResend.days * 2}
              value={resendDays}
              onChange={(e) => setResendDays(e.target.value)} />
            
              <div className="pmleavepg-inline-31">
                Original: {showResend.days} days. You can suggest fewer days.
              </div>
            </div>

            <div className="fg">
              <label className="fl">Comment to Employee *</label>
              <textarea
              className="fta"
              rows={3}
              value={resendComment}
              onChange={(e) => setResendComment(e.target.value)}
              placeholder="e.g. Please reduce to 3 days — sprint deadline on Feb 28." />
            
            </div>

            <div className="pmleavepg-inline-32">
              <button className="btn-o" onClick={() => setShowResend(null)}>Cancel</button>
              <button className="btn" onClick={handleResend}>
                {II("send", 14)} Resend to Employee
              </button>
            </div>
          </div>
        }
      </PMModal>
    </div>);

}

export default PMLeavePg;

